import type { TopAsset } from '@carboncopyco/types';

type UseAssetStatusProps = { asset: TopAsset };
type UseAssetStatusResponse = {
  isDisabled: boolean;
  reasonToDisable?: 'isDeleted' | 'isInactive';
};

export const useAssetStatus = ({
  asset,
}: UseAssetStatusProps): UseAssetStatusResponse => {
  const reasonToDisable =
    asset.status === 'deleted'
      ? 'isDeleted'
      : asset.status === 'inactive'
        ? 'isInactive'
        : undefined;
  return {
    reasonToDisable,
    isDisabled: !!reasonToDisable,
  };
};
